// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"ConfirmationPop_ConfirmationPop__3YhV1","modalBody":"ConfirmationPop_modalBody__6wqxS"};